import { VasttrafikGidHelper } from '../../react/helpers/vasttrafik-gid.helper';
import { ClientSideStorageItems, ClientSideStorageService } from '../../react/services/client-side-storage.service';

export class MunicipalitySelectorModalHelper {
  public static OPEN_EVENT_NAME = 'openMunicipalitySelectorModal';
  public static NO_SELECTED_MUNICIPALITY_GID = 'no-selected-municipality-gid';
  public static NO_SELECTED_MUNICIPALITY_NAME = 'no-selected-municipality-name';

  public static openMunicipalitySelectorModal(): void {
    window.postMessage({ type: this.OPEN_EVENT_NAME }, window.location.origin);
  }

  public static getSelectedMunicipalityFromCookies(): { gid: string; name: string } | undefined {
    try {
      const cookie = ClientSideStorageService.getCookie(ClientSideStorageItems.Cookie.SelectedMunicipality);
      if (!cookie) {
        return undefined;
      }

      const parsedMunicipality = JSON.parse(cookie);
      if (parsedMunicipality?.gid && parsedMunicipality?.name) {
        return parsedMunicipality;
      }
    } catch {
      /* empty */
    }

    ClientSideStorageService.setCookie(ClientSideStorageItems.Cookie.SelectedMunicipality, '', 0);
    return undefined;
  }

  public static getSelectedMunicipalityFromUrl(): string | undefined {
    const urlParams = new URLSearchParams(location.search);
    const municipalityGid = Number(urlParams.get('m'));

    if (VasttrafikGidHelper.isMunicipalityGid(municipalityGid.toString())) {
      return municipalityGid.toString();
    }

    return undefined;
  }
}
